import React from "react"
import Card from "../../../../containers/Card/Card"
import Chips from "../../../Chips/Chips"
import {BusinessVertical} from "../../../../resources/application"
import {chipMaxWidth} from "../../riskSettings"
import ProhibitedBusinessVerticalsIcon from "../ProhibitedBusinessVerticalsIcon"
import ProhibitedBusinessVerticalsSubtitle from "../ProhibitedBusinessVerticalsSubtitle"
import {isEqualWith} from "lodash"
import TitleWithBadge from "../../../TitleWithBadge/TitleWithBadge"
import {isEqualAsSet} from "../../../../utilities/set"

interface ProhibitedBusinessVerticalsProps {
	value: string[]
	defaultValue?: string[]
}

export default function ProhibitedBusinessVerticalsViewMode({value, defaultValue}: ProhibitedBusinessVerticalsProps) {
	return (
		<div className="risk-settings-card">
			<Card
				title={
					<TitleWithBadge
						title="Prohibited Business Verticals"
						showBadge={defaultValue ? !isEqualWith(value, defaultValue, isEqualAsSet) : undefined}
						badgeText="Exceptions"
						badgeTooltip={`This onboarding rules for this Org<br>
									include exceptions to the bank's<br>
									default onboarding rules.`}
						badgeTooltipClassname="risk-settings-badge-tooltip"
						badgeTooltipKey="prohibited-business-verticals-badge-tooltip"
						heading="h1"
					/>
				}
				subtitle={<ProhibitedBusinessVerticalsSubtitle />}
				className="header-with-large-gap"
				icon={<ProhibitedBusinessVerticalsIcon />}
			>
				{value.length > 0 ? (
					<Chips
						labels={value.map((v) => BusinessVertical[v as keyof typeof BusinessVertical])}
						readonly
						maxWidth={chipMaxWidth}
					/>
				) : (
					<span className="no-values-selected">No verticals selected</span>
				)}
			</Card>
		</div>
	)
}
